import { Drawer } from '@/components';
import type { FC } from 'react';
import { useSnapshotDrawerState } from './SnapshotDrawerStateProvider';
import { SnapshotForm } from './SnapshotForm';

export const SnapshotFormDrawer: FC = () => {
  const { drawerState, setDrawerState } = useSnapshotDrawerState();

  const editTargetId = drawerState.open ? drawerState.id : undefined;
  const initialValues = drawerState.open
    ? drawerState.initialValues
    : undefined;

  return (
    <Drawer
      open={drawerState.open}
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnHidden
    >
      <SnapshotForm initialValues={initialValues} editTargetId={editTargetId} />
    </Drawer>
  );
};
